import Vote from "./vote";

export default Vote;